<!--
 * @Author: cryi.liu
 * @Date: 2020-07-13 14:14:55
 * @LastEditTime: 2020-07-16 11:34:13
 * @Description: 添加第三方员工
-->
<template>
  <div class="add-third-party-user">
    <p>
      <span>分公司：</span>
      <i-select v-model="examObject.branchCode" size="small">
        <i-option
          v-for="branch in branchs"
          :key="branch.code"
          :value="branch.code">{{ branch.name }}</i-option>
      </i-select>
    </p>
    <p>
      <span>办事处：</span>
      <i-select v-model="examObject.subBranchCode" size="small">
        <i-option
          v-for="subBranch in subBranchs"
          :key="subBranch.code"
          :value="subBranch.code">{{ subBranch.name }}</i-option>
      </i-select>
    </p>
    <p>
      <span>渠道：</span>
      <i-select v-model="examObject.channelCode" size="small">
         <i-option
          v-for="channel in channels"
          :key="channel.code"
          :value="channel.code">{{ channel.name }}</i-option>
      </i-select>
    </p>
    <p>
      <span>小渠道：</span>
      <i-select v-model="examObject.comChannelCode" size="small">
        <i-option
          v-for="subChannel in subChannels"
          :key="subChannel.code"
          :value="subChannel.code">{{ subChannel.name }}</i-option>
      </i-select>
    </p>
    <p>
      <span>身份类别：</span>
      <i-select v-model="examObject.userTypeId" size="small">
        <i-option
          v-for="userType in userTypes"
          :key="userType.code"
          :value="userType.code">{{ userType.name }}</i-option>
      </i-select>
    </p>
    <p>
      <span>身份类别明细：</span>
      <i-select
        v-model="examObject.userTypeDetailId"
        size="small" @on-change="userTypeDetailChangedHandler">
        <i-option
          v-for="userTypeDetail in userTypesDetail"
          :key="userTypeDetail.code"
          :value="userTypeDetail.code">{{ userTypeDetail.name }}</i-option>
      </i-select>
    </p>
    <p>
      <span>星级：</span>
      <i-select v-model="examObject.starLevel" size="small">
        <i-option
          v-for="star in stars"
          :key="star.code"
          :value="star.code">{{ star.name }}</i-option>
      </i-select>
    </p>
    <p>
      <span>主营产品：</span>
      <i-select v-model="examObject.mainGroup" size="small">
        <i-option
          v-for="mainProduct in mainProducts"
          :key="mainProduct.code"
          :value="mainProduct.code">{{ mainProduct.name }}</i-option>
      </i-select>
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';

const branchs = [
  { name: '所有分公司', code: 'all' },
  { name: '北京', code: 'N' },
  { name: '成都', code: 'W' },
  { name: '福州', code: 'J' },
  { name: '广州', code: 'S' },
  { name: '杭州', code: 'D' },
  { name: '济南', code: 'I' },
  { name: '南京', code: 'B' },
  { name: '上海', code: 'E' },
  { name: '深圳', code: 'C' },
  { name: '沈阳', code: 'A' },
  { name: '天津', code: 'K' },
  { name: '武汉', code: 'F' },
  { name: '西安', code: 'G' },
];

const subBranchs = [
  { name: '所有办事处', code: 'all' },
];

const channels = [
  { name: '所有渠道', code: 'all' },
  { name: 'Designated', code: 'ZA50' },
  { name: 'NAS', code: 'ZA10' },
  { name: 'RA', code: 'ZA20' },
  { name: 'Web Sales', code: 'ZWEB' },
  { name: 'Direct', code: 'ZA40' },
  { name: 'Fashion Shop Channel', code: 'ZAG0' },
  { name: 'Mobile', code: 'ZAD0' },
  { name: 'Wholesaler', code: 'ZAE0' },
  { name: 'Camera', code: 'ZAF0' },
];

const subChannels = [
  { name: '所有小渠道', code: 'all' },
];

const userTypes = [
  { name: '所有', code: 'all' },
  { name: '促销员', code: '202' },
  { name: '零售专员', code: '203' },
  { name: 'Area Rep_AVIT', code: '200' },
  { name: '产品培训师', code: '201' },
  { name: 'Sony Store', code: '204' },
  { name: 'Designated Staff', code: '205' },
  { name: '体验顾问', code: '207' },
  { name: '销售支持类', code: '208' },
  { name: 'Camera Staff', code: '209' },
  { name: 'Web Staff', code: '210' },
  { name: '承包商', code: '211' },
  { name: 'dealer', code: '212' },
  { name: 'Pro Staff', code: '213' },
];

const userTypesDetail = [
  { name: '所有', code: 'all' },
];

const stars = [
  { name: '所有', code: 'all' },
  { name: 'Star 1', code: 'Star 1' },
  { name: 'Star 2', code: 'Star 2' },
  { name: 'Star 3', code: 'Star 3' },
  { name: 'Star 4', code: 'Star 4' },
  { name: 'Star 5', code: 'Star 5' },
  { name: 'Star 6', code: 'Star 6' },
];

const mainProducts = [
  { name: '所有主营产品', code: 'all' },
  { name: 'MOBILE', code: 'MOBILE' },
  { name: 'BDPLAY', code: 'BDPLAY' },
  { name: 'Display', code: 'Display' },
  { name: 'PV|DSC', code: 'V|DSC' },
  { name: 'HAV', code: 'HAV' },
  { name: 'PA', code: 'PA' },
  { name: 'VAIO', code: 'VAIO' },
  { name: 'ILC', code: 'ILC' },
  { name: 'DI+VAIO', code: 'DI+VAIO' },
];

export default {
  name: 'AddThirdPartyUser',
  data() {
    return {
      branchs,
      subBranchs,
      channels,
      subChannels,
      userTypes,
      userTypesDetail,
      stars,
      mainProducts,
      examObject: {
        branchCode: 'all',
        subBranchCode: 'all',
        channelCode: 'all',
        comChannelCode: 'all',
        userTypeId: 'all',
        userTypeDetailId: 'all',
        starLevel: 'all',
        mainGroup: 'all',
      },
    };
  },
  computed: {
    ...mapGetters({
      thirdPartyUserRule: 'createPaperStore/thirdPartyUserRule',
    }),
    selectBranch() {
      return this.examObject.branchCode;
    },
    selectSubBranch() {
      return this.examObject.subBranchCode;
    },
    selectChannel() {
      return this.examObject.channelCode;
    },
    selectComChannel() {
      return this.examObject.comChannelCode;
    },
    selectUserType() {
      return this.examObject.userTypeId;
    },
    selectUserTypeDetail() {
      return this.examObject.userTypeDetailId;
    },
    selectStarLevel() {
      return this.examObject.starLevel;
    },
    selectMainProduct() {
      return this.examObject.mainGroup;
    },
  },
  watch: {
    selectBranch(branchCode) {
      this.examObject.subBranchCode = 'all';

      const thirdPartyUserRule = JSON.parse(JSON.stringify(this.thirdPartyUserRule));
      thirdPartyUserRule.branchCode = branchCode;
      thirdPartyUserRule.subBranchCode = 'all';
      this.setThirdPartyUserRule({ thirdPartyUserRule });

      this.requestSubBranchs();
    },
    selectSubBranch(subBranchCode) {
      const thirdPartyUserRule = JSON.parse(JSON.stringify(this.thirdPartyUserRule));
      thirdPartyUserRule.subBranchCode = subBranchCode;
      this.setThirdPartyUserRule({ thirdPartyUserRule });
    },
    selectChannel(channelCode) {
      this.examObject.comChannelCode = 'all';

      const thirdPartyUserRule = JSON.parse(JSON.stringify(this.thirdPartyUserRule));
      thirdPartyUserRule.channelCode = channelCode;
      thirdPartyUserRule.comChannelCode = 'all';
      this.setThirdPartyUserRule({ thirdPartyUserRule });

      this.requestSubChanels();
    },
    selectComChannel(comChannelCode) {
      const thirdPartyUserRule = JSON.parse(JSON.stringify(this.thirdPartyUserRule));
      thirdPartyUserRule.comChannelCode = comChannelCode;
      this.setThirdPartyUserRule({ thirdPartyUserRule });
    },
    selectUserType(userTypeId) {
      this.examObject.userTypeDetail = 'all';
      this.examObject.mainProduct = 'all';

      const thirdPartyUserRule = JSON.parse(JSON.stringify(this.thirdPartyUserRule));
      thirdPartyUserRule.userTypeId = userTypeId;
      thirdPartyUserRule.comChannelCode = 'all';
      this.setThirdPartyUserRule({ thirdPartyUserRule });

      this.requestUserTypesDetail();
    },
    selectUserTypeDetail(userTypeDetailId) {
      const thirdPartyUserRule = JSON.parse(JSON.stringify(this.thirdPartyUserRule));
      thirdPartyUserRule.userTypeDetailId = userTypeDetailId;
      this.setThirdPartyUserRule({ thirdPartyUserRule });
    },
    selectStarLevel(starLevel) {
      const thirdPartyUserRule = JSON.parse(JSON.stringify(this.thirdPartyUserRule));
      thirdPartyUserRule.starLevel = starLevel;
      this.setThirdPartyUserRule({ thirdPartyUserRule });
    },
    selectMainProduct(mainGroup) {
      const thirdPartyUserRule = JSON.parse(JSON.stringify(this.thirdPartyUserRule));
      thirdPartyUserRule.mainGroup = mainGroup;
      this.setThirdPartyUserRule({ thirdPartyUserRule });
    },
  },
  methods: {
    ...mapActions({
      setThirdPartyUserRule: 'createPaperStore/invokeSetThirdPartyUserRule',
    }),
    /**
     * 请求分公司列表
     */
    async requestSubBranchs() {
      if (this.selectBranch !== 'all') {
        const url = `/sf/queryHeadAction.do?branchCode=${this.selectBranch}&method=fetchSubranches`;
        const result = await axios.get(url);
        this.subBranchs = [{ name: '所有办事处', code: 'all' }, ...result.data];
      } else {
        this.subBranchs = [{ name: '所有办事处', code: 'all' }];
        this.examObject.subBranchCode = 'all';
      }
    },
    /**
     * 请求小渠道列表
     */
    async requestSubChanels() {
      if (this.selectChannel !== 'all') {
        const url = `/sf/queryHeadAction.do?channelCode=${this.selectChannel}&method=fetchCompoChannels`;
        const result = await axios.get(url);
        this.subChannels = [{ name: '所有小渠道', code: 'all' }, ...result.data];
      } else {
        this.subChannels = [{ name: '所有小渠道', code: 'all' }];
        this.examObject.comChannelCode = 'all';
      }
    },
    /**
     * 请求身份明细列表
     */
    async requestUserTypesDetail() {
      if (this.selectUserType !== 'all') {
        const url = `/searchHead.do?method=fetchUserTypeDetails&userTypeId=${this.selectUserType}`;
        const result = await axios.get(url);
        const { data } = result;
        data.forEach((item) => {
          item.code = item.id;
        });

        this.userTypesDetail = [{ name: '所有', code: 'all' }, ...data];
      } else {
        this.userTypesDetail = [{ name: '所有', code: 'all' }];
        this.examObject.userTypeDetailId = 'all';
      }
    },
    /**
     * 用户类型明细下拉选择改变
     */
    userTypeDetailChangedHandler(value) {
      this.examObject.mainGroup = 'all';

      if (value === 'all') {
        this.mainProducts = mainProducts;
      } else {
        this.userTypesDetail.forEach((userTypeDetail) => {
          if (value === userTypeDetail.code) {
            const tempMainProducts = [];

            if (userTypeDetail.mainProducts && userTypeDetail.mainProducts.length) {
              userTypeDetail.mainProducts.forEach((valueProd) => {
                tempMainProducts.push({ name: valueProd, code: valueProd });
              });
            }

            this.mainProducts = [{ name: '所有主营产品', code: 'all' }, ...tempMainProducts];
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.add-third-party-user {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  > p {
    flex: 0 0 calc(100% / 4);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;

    /deep/ .ivu-select {
      width: 120px;
    }
  }
}
</style>
